export default __webpack_public_path__ + "static/media/wallet.ae78bdcb.svg";